import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import client from '@/api/client'

function compare(a: string, b: string): number {
  const pa = a.split('.').map(Number)
  const pb = b.split('.').map(Number)
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const x = pa[i] ?? 0, y = pb[i] ?? 0
    if (x !== y) return x - y
  }
  return 0
}

export async function isUpgradeRequired(): Promise<boolean> {
  if (!Capacitor.isNativePlatform()) return false
  const platform = Capacitor.getPlatform() as 'ios' | 'android'

  try {
    const [{ version }, { data }] = await Promise.all([
      App.getInfo(),
      client.get('/mobile/min-version'),
    ])
    const required = data.data[platform]
    return compare(version, required) < 0
  } catch (err) {
    console.error('[useMinVersion] check failed, allowing boot', err)
    return false
  }
}
